/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AccountIEnumerableResponse } from '../models';
import { BankBranchIEnumerableResponse } from '../models';
import { BooleanResponse } from '../models';
import { DeletePracticeAccountRequest } from '../models';
import { PracticeAccountRequest } from '../models';
import { Request } from '../models';
/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {DeletePracticeAccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountDeleteAccountInvestigationIdPost: async (investigationId: number, body?: DeletePracticeAccountRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2AccountDeleteAccountInvestigationIdPost.');
            }
            const localVarPath = `/api/v2/Account/DeleteAccount/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns Accounts
         * @param {number} practiceId 
         * @param {number} [accountTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountGetAccountsByPracticeIdPracticeIdGet: async (practiceId: number, accountTypeId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2AccountGetAccountsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v2/Account/GetAccountsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountTypeId !== undefined) {
                localVarQueryParameter['accountTypeId'] = accountTypeId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns Accounts
         * @param {number} practiceId 
         * @param {number} investigationId 
         * @param {number} [accountTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountGetAccountsByPracticeIdPracticeIdInvestigationIdGet: async (practiceId: number, investigationId: number, accountTypeId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2AccountGetAccountsByPracticeIdPracticeIdInvestigationIdGet.');
            }
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2AccountGetAccountsByPracticeIdPracticeIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Account/GetAccountsByPracticeId/{practiceId}/{investigationId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)))
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountTypeId !== undefined) {
                localVarQueryParameter['accountTypeId'] = accountTypeId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns BankBranches
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountGetBankBranchByKeywordSearchPost: async (body?: Request, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Account/GetBankBranchByKeywordSearch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {PracticeAccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountSaveAccountInvestigationIdPost: async (investigationId: number, body?: PracticeAccountRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2AccountSaveAccountInvestigationIdPost.');
            }
            const localVarPath = `/api/v2/Account/SaveAccount/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {DeletePracticeAccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccountDeleteAccountInvestigationIdPost(investigationId: number, body?: DeletePracticeAccountRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await AccountApiAxiosParamCreator(configuration).apiV2AccountDeleteAccountInvestigationIdPost(investigationId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns Accounts
         * @param {number} practiceId 
         * @param {number} [accountTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccountGetAccountsByPracticeIdPracticeIdGet(practiceId: number, accountTypeId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountIEnumerableResponse>> {
            const localVarAxiosArgs = await AccountApiAxiosParamCreator(configuration).apiV2AccountGetAccountsByPracticeIdPracticeIdGet(practiceId, accountTypeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns Accounts
         * @param {number} practiceId 
         * @param {number} investigationId 
         * @param {number} [accountTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccountGetAccountsByPracticeIdPracticeIdInvestigationIdGet(practiceId: number, investigationId: number, accountTypeId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountIEnumerableResponse>> {
            const localVarAxiosArgs = await AccountApiAxiosParamCreator(configuration).apiV2AccountGetAccountsByPracticeIdPracticeIdInvestigationIdGet(practiceId, investigationId, accountTypeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns BankBranches
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccountGetBankBranchByKeywordSearchPost(body?: Request, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankBranchIEnumerableResponse>> {
            const localVarAxiosArgs = await AccountApiAxiosParamCreator(configuration).apiV2AccountGetBankBranchByKeywordSearchPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {PracticeAccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccountSaveAccountInvestigationIdPost(investigationId: number, body?: PracticeAccountRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await AccountApiAxiosParamCreator(configuration).apiV2AccountSaveAccountInvestigationIdPost(investigationId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {DeletePracticeAccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountDeleteAccountInvestigationIdPost(investigationId: number, body?: DeletePracticeAccountRequest, options?: any): AxiosPromise<BooleanResponse> {
            return AccountApiFp(configuration).apiV2AccountDeleteAccountInvestigationIdPost(investigationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns Accounts
         * @param {number} practiceId 
         * @param {number} [accountTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountGetAccountsByPracticeIdPracticeIdGet(practiceId: number, accountTypeId?: number, options?: any): AxiosPromise<AccountIEnumerableResponse> {
            return AccountApiFp(configuration).apiV2AccountGetAccountsByPracticeIdPracticeIdGet(practiceId, accountTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns Accounts
         * @param {number} practiceId 
         * @param {number} investigationId 
         * @param {number} [accountTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountGetAccountsByPracticeIdPracticeIdInvestigationIdGet(practiceId: number, investigationId: number, accountTypeId?: number, options?: any): AxiosPromise<AccountIEnumerableResponse> {
            return AccountApiFp(configuration).apiV2AccountGetAccountsByPracticeIdPracticeIdInvestigationIdGet(practiceId, investigationId, accountTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns BankBranches
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountGetBankBranchByKeywordSearchPost(body?: Request, options?: any): AxiosPromise<BankBranchIEnumerableResponse> {
            return AccountApiFp(configuration).apiV2AccountGetBankBranchByKeywordSearchPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {PracticeAccountRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccountSaveAccountInvestigationIdPost(investigationId: number, body?: PracticeAccountRequest, options?: any): AxiosPromise<BooleanResponse> {
            return AccountApiFp(configuration).apiV2AccountSaveAccountInvestigationIdPost(investigationId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @summary Returns boolean
     * @param {number} investigationId 
     * @param {DeletePracticeAccountRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV2AccountDeleteAccountInvestigationIdPost(investigationId: number, body?: DeletePracticeAccountRequest, options?: any) {
        return AccountApiFp(this.configuration).apiV2AccountDeleteAccountInvestigationIdPost(investigationId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns Accounts
     * @param {number} practiceId 
     * @param {number} [accountTypeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV2AccountGetAccountsByPracticeIdPracticeIdGet(practiceId: number, accountTypeId?: number, options?: any) {
        return AccountApiFp(this.configuration).apiV2AccountGetAccountsByPracticeIdPracticeIdGet(practiceId, accountTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns Accounts
     * @param {number} practiceId 
     * @param {number} investigationId 
     * @param {number} [accountTypeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV2AccountGetAccountsByPracticeIdPracticeIdInvestigationIdGet(practiceId: number, investigationId: number, accountTypeId?: number, options?: any) {
        return AccountApiFp(this.configuration).apiV2AccountGetAccountsByPracticeIdPracticeIdInvestigationIdGet(practiceId, investigationId, accountTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns BankBranches
     * @param {Request} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV2AccountGetBankBranchByKeywordSearchPost(body?: Request, options?: any) {
        return AccountApiFp(this.configuration).apiV2AccountGetBankBranchByKeywordSearchPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean
     * @param {number} investigationId 
     * @param {PracticeAccountRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiV2AccountSaveAccountInvestigationIdPost(investigationId: number, body?: PracticeAccountRequest, options?: any) {
        return AccountApiFp(this.configuration).apiV2AccountSaveAccountInvestigationIdPost(investigationId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
